/**
 * md-vk-bereinigen.js v2 (2026-09-18) — TEMPORAER, Rueckbau ab 2026-10-05.
 *
 * NEU v2 (2026-09-18): Vorpruefung. Bisher las das Skript auf JEDER Seite ~4 s nach dem Laden den Korb frisch (ein zusaetzlicher
 * GET /cart.js je Seitenaufruf), obwohl fast kein Korb mehr _vk traegt. Jetzt prueft es zuerst ueber den gemeinsamen Leser
 * (window.fetch -> mdzo-cart-writer v2: geteilter Read bzw. Merker, kein eigener Netzaufruf) oder direkt am Korb aus dem Ereignis,
 * ob ueberhaupt _vk-Zeilen da sind. Nur dann laeuft der bisherige Weg unveraendert: Ruhefenster, frischer Read (no-store), Bereinigen.
 * Schlaegt die Vorpruefung fehl, gilt das alte Verhalten.
 *
 * Altlast nach dem Abschalten des Google-Versandmarkers (md-versand.js, 14.09.2026 15:25 UTC): Warenkorbzeilen tragen
 * noch die Property _vk=g. Legt der Kunde dieselbe Variante erneut ein (jetzt ohne Property), entsteht eine ZWEITE Zeile
 * statt Menge +1 (Beleg add_to_cart_edge_check.js E2; 59 von 118 offenen Checkouts der letzten 3 Tage betroffen).
 *
 * Dieses Skript entfernt _vk aus betroffenen Zeilen. Gemessen 14.09. (change_props_experiment.js, vk_bereinigen_check.js):
 *  - change.js mit properties {} ist fuer Shopify ein No-op (200, nichts geaendert) -> bleiben keine Properties uebrig,
 *    wird die Zeile auf 0 gesetzt und dieselbe Menge ohne _vk per add.js neu eingelegt; Shopify fuehrt sie mit einer
 *    gleichartigen Zeile zusammen (Ergebnis x2 statt zwei Zeilen). Bleiben andere Properties, tauscht change.js sie
 *    direkt (mit quantity, sonst setzt Shopify die Menge auf 1).
 *  - GLEICHZEITIGE Cart-Writes verschiedener Skripte sind gefaehrlich: Ein Attribut-Write (update.js), der waehrend unseres
 *    Entfernens unterwegs war, hat die entfernte Zeile wieder hergestellt (1 von 3 Laeufen: x2 + x1 statt x2). Deshalb
 *    beobachtet dieses Skript alle Cart-Writes ueber window.fetch und arbeitet erst in einem RUHEFENSTER: kein Write
 *    unterwegs und seit RUHE_MS keiner abgeschlossen. Danach wird der Korb frisch gelesen (cache: no-store).
 *
 * Ausloeser: on:cart:add / on:line-item:change / Laden jeder Seite mit cart-items. Kosten je Ausloeser seit v2: kein eigener
 * Netzaufruf, solange kein _vk im Korb ist; sonst wie v1 ein frischer GET /cart.js je Schritt;
 * Aenderungen nur bei _vk-Zeilen. Keine Verbindung nach aussen.
 */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var CART_JS = (routes.cart || '/cart') + '.js';
  var CART_CHANGE = routes.cartChange || '/cart/change.js';
  var CART_ADD = '/cart/add.js';
  var RUHE_MS = 4000, MAX_WARTEN_MS = 40000, TAKT_MS = 1000;
  var laeuft = false, timer = null;

  // Cart-Writes aller Skripte beobachten (fetch wird von jedem Aufrufer zur Laufzeit ueber window aufgeloest)
  var unterwegs = 0, letzterWrite = 0;
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (eingabe, init) {
      var url = '';
      try { url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || ''; } catch (e) {}
      var methode = ((init && init.method) || (eingabe && eingabe.method) || 'GET').toUpperCase();
      var cartWrite = methode !== 'GET' && /\/cart\/(add|change|update|clear)/.test(url);
      if (!cartWrite) return fetchOriginal.apply(this, arguments);
      unterwegs++;
      var fertig = function () { unterwegs = Math.max(0, unterwegs - 1); letzterWrite = Date.now(); };
      var p = fetchOriginal.apply(this, arguments);
      p.then(fertig, fertig);
      return p;
    };
  }
  function ruhig() { return unterwegs === 0 && Date.now() - letzterWrite >= RUHE_MS; }

  function post(url, body) {
    return fetchOriginal.call(window, url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function cartLesen() { return fetchOriginal.call(window, CART_JS, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function ohneVk(props) {
    var out = {};
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k) && k !== '_vk') out[k] = props[k];
    return out;
  }
  function markierteZeilen(cart) {
    var items = (cart && cart.items) || [], out = [];
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties;
      if (p && Object.prototype.hasOwnProperty.call(p, '_vk') && items[i].quantity > 0) out.push(items[i]);
    }
    return out;
  }
  function neuRendern() {
    try {
      var cartItems = document.querySelector('cart-items');
      var drawer = document.querySelector('cart-drawer');
      if (cartItems && typeof cartItems.refresh === 'function') cartItems.refresh();
      else if (drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
    } catch (e) { /* Anzeige bleibt bis zum naechsten Rendern alt */ }
  }

  // Eine Zeile bereinigen; loest mit true auf, wenn etwas geschrieben wurde.
  function zeileBereinigen(zeile) {
    var props = ohneVk(zeile.properties || {});
    if (Object.keys(props).length) {
      return post(CART_CHANGE, { id: zeile.key, quantity: zeile.quantity, properties: props }).then(function (r) { return r.ok; });
    }
    var menge = zeile.quantity, vid = zeile.variant_id;
    var einlegen = function () { return post(CART_ADD, { items: [{ id: vid, quantity: menge, properties: {} }] }); };
    return post(CART_CHANGE, { id: zeile.key, quantity: 0 }).then(function (r) {
      if (!r.ok) return false;
      return einlegen().then(function (a) {
        if (a.ok) return true;
        return new Promise(function (res) { setTimeout(res, 1000); }).then(einlegen).then(function (b) { return b.ok; });
      });
    });
  }

  function bereinigen() {
    var geaendert = 0;
    cartLesen().then(function (cart) {
      var zeilen = markierteZeilen(cart);
      var kette = Promise.resolve();
      zeilen.forEach(function (zeile) {
        kette = kette.then(function () {
          if (!ruhig() && unterwegs > 0) return; // fremder Write laeuft gerade: diese Zeile beim naechsten Ausloeser
          return cartLesen().then(function (c) {
            var li = (c && c.items) || [];
            for (var j = 0; j < li.length; j++) if (li[j].key === zeile.key) return zeileBereinigen(li[j]);
            return false;
          }).then(function (ok) { if (ok) geaendert++; }, function () {});
        });
      });
      return kette;
    }).catch(function () {}).then(function () { laeuft = false; if (geaendert) neuRendern(); });
  }

  // Auf ein Ruhefenster warten, dann bereinigen (hoechstens MAX_WARTEN_MS)
  function bald() {
    if (timer) clearTimeout(timer);
    var start = Date.now();
    var pruefen = function () {
      timer = null;
      if (laeuft) return;
      if (ruhig()) { laeuft = true; bereinigen(); return; }
      if (Date.now() - start > MAX_WARTEN_MS) return; // dauerhaft unruhig: naechster Ausloeser
      timer = setTimeout(pruefen, TAKT_MS);
    };
    timer = setTimeout(pruefen, RUHE_MS);
  }

  // v2: erst pruefen, ob es ueberhaupt _vk-Zeilen gibt — ueber window.fetch (NICHT fetchOriginal), damit der gemeinsame Leser
  // des mdzo-cart-writer den Aufruf buendelt. Ein Korb aus dem Ereignis (detail.cart mit items[]) spart auch das.
  function vorpruefen(ereignisKorb) {
    var p = (ereignisKorb && Array.isArray(ereignisKorb.items))
      ? Promise.resolve(ereignisKorb)
      : window.fetch(CART_JS, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
    p.then(function (cart) { if (markierteZeilen(cart).length) bald(); }, function () { bald(); });
  }
  function beiEreignis(ev) { vorpruefen(ev && ev.detail && ev.detail.cart); }
  document.addEventListener('on:cart:add', beiEreignis);
  document.addEventListener('on:line-item:change', beiEreignis);
  function start() { if (document.querySelector('cart-items')) vorpruefen(null); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
